/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkImportFacilityServiceAreasResponse } from './BulkImportFacilityServiceAreasResponse';
import {
    BulkImportFacilityServiceAreasResponseFromJSON,
    BulkImportFacilityServiceAreasResponseFromJSONTyped,
    BulkImportFacilityServiceAreasResponseToJSON,
} from './BulkImportFacilityServiceAreasResponse';

/**
 * 
 * @export
 * @interface BulkImportFacilityServiceAreas200Response
 */
export interface BulkImportFacilityServiceAreas200Response {
    /**
     * 
     * @type {BulkImportFacilityServiceAreasResponse}
     * @memberof BulkImportFacilityServiceAreas200Response
     */
    data?: BulkImportFacilityServiceAreasResponse;
}

/**
 * Check if a given object implements the BulkImportFacilityServiceAreas200Response interface.
 */
export function instanceOfBulkImportFacilityServiceAreas200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulkImportFacilityServiceAreas200ResponseFromJSON(json: any): BulkImportFacilityServiceAreas200Response {
    return BulkImportFacilityServiceAreas200ResponseFromJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreas200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkImportFacilityServiceAreas200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : BulkImportFacilityServiceAreasResponseFromJSON(json['data']),
    };
}

export function BulkImportFacilityServiceAreas200ResponseToJSON(value?: BulkImportFacilityServiceAreas200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': BulkImportFacilityServiceAreasResponseToJSON(value.data),
    };
}

